<app-side-nav></app-side-nav>
<div class="max-w-3xl mx-auto px-4 sm:px-6 py-6 pb-24">
  <div class="md:hidden fixed top-0 left-0 right-0 z-40"
       [style.height.px]="headerHpx || 72"
       [ngClass]="!isDarkMode() ? 'bg-white' : 'bg-[#111827]'">
  </div>

  <!-- 🔹 HEADER MOBILE (fixe, centré, coins arrondis) -->
  <div class="md:hidden fixed top-0 left-0 right-0 z-50 px-4 pt-[env(safe-area-inset-top)]">
    <div #mobileHeader
         class="max-w-md mx-auto rounded-2xl p-4 border transition-all backdrop-blur-md shadow-md"
         [ngClass]="isDarkMode()
       ? 'bg-[#1e1e2f] border-indigo-500/10'
       : 'bg-gradient-to-b from-[#F7F4FF] to-[#EEF0FF] border-[#E6E0FF] shadow-[0_6px_24px_rgba(123,97,255,0.06)]'">

      <!-- Ligne 1 : Brand -->
      <div class="flex items-center gap-2 mb-3">
        <svg class="w-6 h-6 md:w-7 md:h-7"
             [ngClass]="invBridgeLogo"
             fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
        <h1 class="text-lg font-extrabold tracking-tight text-purple-600 drop-shadow-[0_1px_2px_rgba(0,0,0,0.25)]">
          SwapTokens.app
        </h1>
      </div>

      <!-- Ligne 2 : Titre Disclaimer + Thème -->
      <div class="flex items-center justify-between px-1">
        <h1 class="text-base sm:text-lg font-semibold text-purple-600 dark:text-purple-400">
          {{ 'DISCLAIMER.TITLE' | translate }}
        </h1>

        <button (click)="toggleTheme()"
                class="flex items-center justify-center px-3 py-1 rounded-full border transition"
                [ngClass]="isDarkMode()
              ? 'border-white/10 bg-purple-400/10'
              : 'border-[#E6E0FF] bg-white/80 hover:bg-white'">
          <svg *ngIf="isDarkMode(); else lightIcon" class="w-5 h-5 text-purple-300" fill="none"
               stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
          </svg>
          <ng-template #lightIcon>
            <svg class="w-5 h-5 text-purple-500" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="5" />
              <line x1="12" y1="1" x2="12" y2="3" />
              <line x1="12" y1="21" x2="12" y2="23" />
              <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
              <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
              <line x1="1" y1="12" x2="3" y2="12" />
              <line x1="21" y1="12" x2="23" y2="12" />
              <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
              <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
            </svg>
          </ng-template>
        </button>
      </div>
    </div>
  </div>

  <!-- Spacer mobile -->
  <div class="md:hidden" [style.height.px]="headerHpx || 72"></div>

  <!-- 🔥 HEADER DESKTOP -->
  <div class="hidden md:block relative mb-4 rounded-2xl overflow-hidden">
    <div class="relative rounded-2xl p-4 border transition-all backdrop-blur-md hover:border-purple-400/20"
         [ngClass]="isDarkMode()
       ? 'bg-[#1e1e2f]/70 border-indigo-500/10 shadow-md dark:shadow-purple-900/10'
       : 'bg-gradient-to-b from-[#F7F4FF] to-[#EEF0FF] border-[#E6E0FF] shadow-[0_6px_24px_rgba(123,97,255,0.06)]'">

      <div class="flex justify-between items-center gap-4 mb-3">
        <div class="flex items-center gap-2">
          <svg class="w-6 h-6 md:w-7 md:h-7" [ngClass]="invBridgeLogo" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>

          <h1 class="text-base sm:text-lg md:text-2xl font-extrabold bg-clip-text text-transparent"
              [ngClass]="isDarkMode()
            ? invBridgeGradient
            : 'bg-gradient-to-r from-purple-600 to-indigo-600'">
            SwapTokens.app
          </h1>
        </div>

        <h1 class="text-base sm:text-lg font-semibold text-purple-600 dark:text-purple-400">
          {{ 'DISCLAIMER.TITLE' | translate }}
        </h1>
      </div>
    </div>
  </div>

  <!-- Intro -->
  <div class="rounded-2xl border shadow-lg px-5 py-5 sm:py-6 mt-4"
       [ngClass]="isDarkMode()
         ? 'bg-gray-900/60 text-white border-white/10'
         : 'bg-gradient-to-b from-[#F7F4FF] to-[#EEF0FF] text-black border-[#E6E0FF] shadow-[0_6px_24px_rgba(123,97,255,0.06)]'">
    <p class="text-sm leading-relaxed">
      {{ 'DISCLAIMER.INTRO' | translate }}
    </p>
  </div>

  <!-- Sections -->
  <div class="mt-6 space-y-6">

    <section class="rounded-2xl border p-5 shadow-lg"
             [ngClass]="isDarkMode()
               ? 'bg-gray-900/60 text-white border-white/10'
               : 'bg-gradient-to-b from-[#F7F4FF] to-[#EEF0FF] text-black border-[#E6E0FF] shadow-[0_6px_24px_rgba(123,97,255,0.06)]'">
      <h2 class="text-base sm:text-lg font-semibold text-purple-600 dark:text-purple-400">
        1. {{ 'DISCLAIMER.SECTIONS.OBJECT' | translate }}
      </h2>
      <p class="mt-2 text-sm leading-relaxed">
        {{ 'DISCLAIMER.TEXT.OBJECT' | translate }}
      </p>
    </section>

    <section class="rounded-2xl border p-5 shadow-lg"
             [ngClass]="isDarkMode()
               ? 'bg-gray-900/60 text-white border-white/10'
               : 'bg-gradient-to-b from-[#F7F4FF] to-[#EEF0FF] text-black border-[#E6E0FF] shadow-[0_6px_24px_rgba(123,97,255,0.06)]'">
      <h2 class="text-base sm:text-lg font-semibold text-purple-600 dark:text-purple-400">
        2. {{ 'DISCLAIMER.SECTIONS.SERVICE' | translate }}
      </h2>
      <ul class="mt-2 list-disc pl-5 text-sm space-y-1.5 leading-relaxed">
        <li>{{ 'DISCLAIMER.TEXT.SERVICE1' | translate }}</li>
        <li>{{ 'DISCLAIMER.TEXT.SERVICE2' | translate }}</li>
        <li>{{ 'DISCLAIMER.TEXT.SERVICE3' | translate }}</li>
      </ul>
    </section>

    <section class="rounded-2xl border p-5 shadow-lg"
             [ngClass]="isDarkMode()
               ? 'bg-gray-900/60 text-white border-white/10'
               : 'bg-gradient-to-b from-[#F7F4FF] to-[#EEF0FF] text-black border-[#E6E0FF] shadow-[0_6px_24px_rgba(123,97,255,0.06)]'">
      <h2 class="text-base sm:text-lg font-semibold text-purple-600 dark:text-purple-400">
        3. {{ 'DISCLAIMER.SECTIONS.NO_RESPONSIBILITY' | translate }}
      </h2>
      <ul class="mt-2 list-disc pl-5 text-sm space-y-1.5 leading-relaxed">
        <li>{{ 'DISCLAIMER.TEXT.NO_RESP1' | translate }}</li>
        <li>{{ 'DISCLAIMER.TEXT.NO_RESP2' | translate }}</li>
        <li>{{ 'DISCLAIMER.TEXT.NO_RESP3' | translate }}</li>
      </ul>
    </section>

    <section class="rounded-2xl border p-5 shadow-lg"
             [ngClass]="isDarkMode()
               ? 'bg-gray-900/60 text-white border-white/10'
               : 'bg-gradient-to-b from-[#F7F4FF] to-[#EEF0FF] text-black border-[#E6E0FF] shadow-[0_6px_24px_rgba(123,97,255,0.06)]'">
      <h2 class="text-base sm:text-lg font-semibold text-purple-600 dark:text-purple-400">
        4. {{ 'DISCLAIMER.SECTIONS.DEFI_RISKS' | translate }}
      </h2>
      <ul class="mt-2 list-disc pl-5 text-sm space-y-1.5 leading-relaxed">
        <li>{{ 'DISCLAIMER.TEXT.DEFI1' | translate }}</li>
        <li>{{ 'DISCLAIMER.TEXT.DEFI2' | translate }}</li>
        <li>{{ 'DISCLAIMER.TEXT.DEFI3' | translate }}</li>
      </ul>
    </section>

    <section class="rounded-2xl border p-5 shadow-lg"
             [ngClass]="isDarkMode()
               ? 'bg-gray-900/60 text-white border-white/10'
               : 'bg-gradient-to-b from-[#F7F4FF] to-[#EEF0FF] text-black border-[#E6E0FF] shadow-[0_6px_24px_rgba(123,97,255,0.06)]'">
      <h2 class="text-base sm:text-lg font-semibold text-purple-600 dark:text-purple-400">
        5. {{ 'DISCLAIMER.SECTIONS.USER' | translate }}
      </h2>
      <ul class="mt-2 list-disc pl-5 text-sm space-y-1.5 leading-relaxed">
        <li>{{ 'DISCLAIMER.TEXT.USER1' | translate }}</li>
        <li>{{ 'DISCLAIMER.TEXT.USER2' | translate }}</li>
        <li>{{ 'DISCLAIMER.TEXT.USER3' | translate }}</li>
      </ul>
    </section>

    <section class="rounded-2xl border p-5 shadow-lg"
             [ngClass]="isDarkMode()
               ? 'bg-gray-900/60 text-white border-white/10'
               : 'bg-gradient-to-b from-[#F7F4FF] to-[#EEF0FF] text-black border-[#E6E0FF] shadow-[0_6px_24px_rgba(123,97,255,0.06)]'">
      <h2 class="text-base sm:text-lg font-semibold text-purple-600 dark:text-purple-400">
        6. {{ 'DISCLAIMER.SECTIONS.DATA' | translate }}
      </h2>
      <p class="mt-2 text-sm leading-relaxed">
        {{ 'DISCLAIMER.TEXT.DATA' | translate }}
      </p>
    </section>

    <section class="rounded-2xl border p-5 shadow-lg"
             [ngClass]="isDarkMode()
               ? 'bg-gray-900/60 text-white border-white/10'
               : 'bg-gradient-to-b from-[#F7F4FF] to-[#EEF0FF] text-black border-[#E6E0FF] shadow-[0_6px_24px_rgba(123,97,255,0.06)]'">
      <h2 class="text-base sm:text-lg font-semibold text-purple-600 dark:text-purple-400">
        7. {{ 'DISCLAIMER.SECTIONS.LIMITATION' | translate }}
      </h2>
      <p class="mt-2 text-sm leading-relaxed">
        {{ 'DISCLAIMER.TEXT.LIMITATION' | translate }}
      </p>
    </section>

    <section class="rounded-2xl border p-5 shadow-lg"
             [ngClass]="isDarkMode()
               ? 'bg-gray-900/60 text-white border-white/10'
               : 'bg-gradient-to-b from-[#F7F4FF] to-[#EEF0FF] text-black border-[#E6E0FF] shadow-[0_6px_24px_rgba(123,97,255,0.06)]'">
      <h2 class="text-base sm:text-lg font-semibold text-purple-600 dark:text-purple-400">
        8. {{ 'DISCLAIMER.SECTIONS.LAW' | translate }}
      </h2>
      <p class="mt-2 text-sm leading-relaxed">
        {{ 'DISCLAIMER.TEXT.LAW' | translate }}
      </p>
    </section>

    <section class="rounded-2xl border p-5 shadow-lg"
             [ngClass]="isDarkMode()
               ? 'bg-gray-900/60 text-white border-white/10'
               : 'bg-gradient-to-b from-[#F7F4FF] to-[#EEF0FF] text-black border-[#E6E0FF] shadow-[0_6px_24px_rgba(123,97,255,0.06)]'">
      <h2 class="text-base sm:text-lg font-semibold text-purple-600 dark:text-purple-400">
        9. {{ 'DISCLAIMER.SECTIONS.CONTACT' | translate }}
      </h2>
      <p class="mt-2 text-sm leading-relaxed">
        <a href="mailto:contact&#64;swaptokens.app" class="underline">contact&#64;swaptokens.app</a>
      </p>
    </section>
  </div>

  <!-- Rappel discret -->
  <div class="text-xs text-center text-gray-400 dark:text-gray-500 italic mt-8">
    {{ 'DISCLAIMER.ACCEPT_NOTICE' | translate }}
  </div>
</div>

<!-- Backdrop -->
<div *ngIf="showFooterMenu"
     class="fixed inset-0 z-[59]"
     (click)="closeFooterMenu()"></div>

<!-- Sous-menu Info (mobile) -->
<ul *ngIf="showFooterMenu"
    class="fixed z-[10000] bottom-[72px] left-4 w-[90vw] max-w-xs rounded-2xl shadow-lg border transition-all duration-300 ease-in-out
     backdrop-blur-md backdrop-saturate-150"
    [ngClass]="isDarkMode()
      ? 'bg-gray-900/20 text-white border-white/10'
      : 'bg-white/20 text-gray-800 border-black/10'"
    (click)="$event.stopPropagation()">
  <li>
    <a routerLink="/a-propos"
       (click)="showFooterMenu = false"
       class="block px-4 py-3 rounded-lg border border-transparent hover:border-purple-500 transition duration-200 text-sm font-semibold"
       [ngClass]="isDarkMode() ? 'text-purple-300' : 'text-purple-700'">
      {{ 'ABOUT' | translate }}
    </a>
  </li>

  <li>
    <a routerLink="/disclaimer"
       (click)="showFooterMenu = false"
       class="block px-4 py-3 rounded-lg border border-transparent hover:border-purple-500 transition duration-200 text-sm font-semibold"
       [ngClass]="isDarkMode() ? 'text-purple-300' : 'text-purple-700'">
      {{ 'DISCLAIMER_NAV' | translate }}
    </a>
  </li>
</ul>

<app-settings *ngIf="showSettings" class="fixed bottom-[260px] right-4 z-[9999] w-[300px] rounded shadow-lg"
              (currencyChange)="onCurrencyChanged?.($event)"></app-settings>

<div class="md:hidden h-20"></div>
<app-footer-nav mode="default" (settingsClick)="showSettings = !showSettings" (infoClick)="toggleFooterMenu()"></app-footer-nav>
